// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DNY2A","hideOnMobileAssessment":"styles_hideOnMobileAssessment__CZUeG","text":"styles_text__NWARB"};